import clsx from "clsx";
import { useBrandingStore } from "../../store/brandingStore";
import { logoUrl } from "../../api/branding";

type Size = "sm" | "md" | "lg";

interface Props {
  size?: Size;
  withText?: boolean;
  className?: string;
}

const HEIGHT: Record<Size, string> = {
  sm: "h-6",
  md: "h-10",
  lg: "h-16",
};

const TEXT: Record<Size, string> = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
};

export function AppLogo({ size = "sm", withText = true, className }: Props) {
  const { app_name, has_logo, updated_at } = useBrandingStore();
  const trimmedName = (app_name || "").trim();
  const showText = withText && size === "lg" && trimmedName.length > 0;

  if (has_logo) {
    return (
      <div className={clsx("flex items-center gap-2", className)}>
        <img
          src={logoUrl(updated_at)}
          alt={trimmedName || "logo"}
          className={clsx(HEIGHT[size], "w-auto object-contain")}
        />
        {showText && (
          <span className={clsx("font-semibold text-text", TEXT[size])}>{trimmedName}</span>
        )}
      </div>
    );
  }

  if (trimmedName) {
    return (
      <div className={clsx("font-bold text-accent", TEXT[size], className)}>
        {trimmedName}
      </div>
    );
  }

  return null;
}
